var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelescope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 426.667,
    height: 221.119,
    viewBox: "0 0 426.667 221.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_224",
    "data-name": "Rettangolo 224",
    width: 426.667,
    height: 165.239,
    fill: "#3f3d94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_202",
    "data-name": "Rettangolo 202",
    width: 111.112,
    height: 173.061,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3237",
    "data-name": "Tracciato 3237",
    d: "M21.878,45.408a3.852,3.852,0,0,0,2.276,3.179,12.043,12.043,0,0,0,10.92,0,3.824,3.824,0,0,0,2.241-3.137l.18-24.5a3.821,3.821,0,0,1-2.241,3.135,12.03,12.03,0,0,1-10.92,0A3.857,3.857,0,0,1,22.058,20.9Z",
    transform: "translate(-21.878 -20.902)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3245",
    "data-name": "Tracciato 3245",
    d: "M4.181,36.2c-1.293.745-2.1,2.346-2.1,4.624A15.628,15.628,0,0,0,9.171,53.1c1.942,1.114,3.7,1.217,4.981.482L51.759,32.14c-1.278.734-3.036.631-4.979-.48a15.633,15.633,0,0,1-7.088-12.277c0-2.28.8-3.88,2.1-4.624Z",
    transform: "translate(-2.083 -14.759)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3252",
    "data-name": "Tracciato 3252",
    d: "M13.092,34.376c-1.87,1.072-3.028,3.381-3.028,6.669,0,6.542,4.582,14.48,10.227,17.718,2.8,1.607,5.343,1.756,7.186.695L81.753,28.514c-1.844,1.057-4.382.912-7.184-.7C68.924,24.578,64.34,16.64,64.34,10.1c0-3.289,1.158-5.6,3.028-6.671Z",
    transform: "translate(-10.064 -3.429)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3259",
    "data-name": "Tracciato 3259",
    d: "M67.309,29.594c.055-.028.112-.059.167-.092ZM33.692,9.762c-2.173,1.245-3.519,3.929-3.519,7.75,0,7.6,5.325,16.82,11.885,20.584,3.256,1.868,6.2,2.039,8.348.809l16.9-9.311c-2.131,1.127-5.009.919-8.182-.9C52.566,24.931,47.243,15.708,47.243,8.107c0-3.819,1.346-6.5,3.519-7.748Z",
    transform: "translate(-30.173 -0.359)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_215",
    "data-name": "Rettangolo 215",
    width: 25,
    height: 29.762,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_208",
    "data-name": "Rettangolo 208",
    width: 10.308,
    height: 4.605,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_209",
    "data-name": "Rettangolo 209",
    width: 3.974,
    height: 11.082,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_210",
    "data-name": "Rettangolo 210",
    width: 6.102,
    height: 11.485,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_211",
    "data-name": "Rettangolo 211",
    width: 10.333,
    height: 7.163,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_212",
    "data-name": "Rettangolo 212",
    width: 22.432,
    height: 28.227,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_223",
    "data-name": "Rettangolo 223",
    width: 23.093,
    height: 27.904,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_222",
    "data-name": "Rettangolo 222",
    width: 23.094,
    height: 27.904,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_216",
    "data-name": "Rettangolo 216",
    width: 9.593,
    height: 4.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_217",
    "data-name": "Rettangolo 217",
    width: 3.526,
    height: 10.323,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_218",
    "data-name": "Rettangolo 218",
    width: 5.504,
    height: 10.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_219",
    "data-name": "Rettangolo 219",
    width: 9.556,
    height: 6.811,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_220",
    "data-name": "Rettangolo 220",
    width: 20.66,
    height: 26.53,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_715",
    "data-name": "Raggruppa 715",
    transform: "translate(25.833 -80.881)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_278",
    "data-name": "Raggruppa 278",
    transform: "translate(-25.833 136.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_277",
    "data-name": "Raggruppa 277",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3281",
    "data-name": "Tracciato 3281",
    d: "M144.466,9.858A316.128,316.128,0,0,0,241.5,5.919c82.04-16.3,149.532,4.822,166.494,18.11,19.69,15.441,22.94,35.757,13.826,54.324s-29.625,35.522-54.2,50.268c-19.219,11.522-41.672,22.1-68.548,28.11-26.257,5.87-55.029,7.031-83.146,7.823-36.163,1.02-72.946,1.536-107.388-3.192-28.085-3.851-56.938-13.371-59.386-28.4-2.08-12.807,15.913-25.412,13.407-38.188C59.039,76.888,18.782,68.024,5.478,51.647-10.044,32.55,9.653,11.508,36.592,7c28.081-4.7,72.594-1.306,107.874,2.859",
    transform: "translate(0 0)",
    fill: "#3f3d94"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_229",
    "data-name": "Raggruppa 229",
    transform: "translate(131.944 102.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_212",
    "data-name": "Raggruppa 212",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_211",
    "data-name": "Raggruppa 211",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3221",
    "data-name": "Tracciato 3221",
    d: "M102.761,78.576a43.569,43.569,0,0,1-7.792,5.683C79.935,93,58.349,95.659,39.276,92.243a70.991,70.991,0,0,1-22.862-7.984C5.463,77.936-.007,69.636.018,61.349L0,67.58c-.024,8.287,5.446,16.587,16.4,22.91a70.99,70.99,0,0,0,22.862,7.984c19.073,3.413,40.659.752,55.694-7.984a43.569,43.569,0,0,0,7.792-5.683c5.551-5.156,8.333-11.03,8.351-16.91l.018-6.231c-.018,5.88-2.8,11.753-8.351,16.91",
    transform: "translate(0 73.149)",
    fill: "#ababab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222",
    "data-name": "Tracciato 3222",
    d: "M94.7,56.168c21.763,12.566,21.88,32.938.257,45.5s-56.793,12.564-78.556,0-21.877-32.935-.257-45.5,56.795-12.566,78.556,0",
    transform: "translate(0.009 55.735)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3223",
    "data-name": "Tracciato 3223",
    d: "M27.346,27.473l-3.08-1.791.171,60.572,3.08,1.789Z",
    transform: "translate(28.933 30.622)",
    fill: "#002340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3224",
    "data-name": "Tracciato 3224",
    d: "M30.449,26.656l-3.08-1.791-3.1,1.793,3.08,1.789Z",
    transform: "translate(28.934 29.647)",
    fill: "#191e20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3225",
    "data-name": "Tracciato 3225",
    d: "M25.671,27.473l.171,60.57,3.1-1.791-.173-60.57Z",
    transform: "translate(30.608 30.622)",
    fill: "#003562"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3226",
    "data-name": "Tracciato 3226",
    d: "M27.252,32.275l3.08-1.789L27.759,31l-3.078,1.791Z",
    transform: "translate(29.427 36.35)",
    fill: "#15191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3227",
    "data-name": "Tracciato 3227",
    d: "M58.4,106.6l3.08-1.791L28.934,30.486l-3.08,1.789Z",
    transform: "translate(30.826 36.349)",
    fill: "#003562"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3228",
    "data-name": "Tracciato 3228",
    d: "M27.252,31.3l-2.572.52,32.545,74.32,2.574-.511Z",
    transform: "translate(29.427 37.323)",
    fill: "#002340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3229",
    "data-name": "Tracciato 3229",
    d: "M27.115,32.275l-3.08-1.789L26.606,31l3.082,1.791Z",
    transform: "translate(28.657 36.35)",
    fill: "#15191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3230",
    "data-name": "Tracciato 3230",
    d: "M12.269,106.6l-3.08-1.791L41.736,30.486l3.08,1.789Z",
    transform: "translate(10.956 36.349)",
    fill: "#002340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3231",
    "data-name": "Tracciato 3231",
    d: "M43.141,31.3l2.574.52-32.547,74.32-2.574-.511Z",
    transform: "translate(12.631 37.323)",
    fill: "#003562"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_214",
    "data-name": "Raggruppa 214",
    transform: "translate(47.964 45.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_213",
    "data-name": "Raggruppa 213",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3232",
    "data-name": "Tracciato 3232",
    d: "M29.1,20.922l-.18,24.506,0,.059L29.1,20.981v-.059",
    transform: "translate(-13.484 -20.878)",
    fill: "#052234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3233",
    "data-name": "Tracciato 3233",
    d: "M29.435,20.949l-.18,24.506a2.974,2.974,0,0,1-.618,1.688l.18-24.506a2.963,2.963,0,0,0,.618-1.688",
    transform: "translate(-13.819 -20.846)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3234",
    "data-name": "Tracciato 3234",
    d: "M32.171,21.719l-.18,24.506a5.279,5.279,0,0,1-1.622,1.388,10.619,10.619,0,0,1-4.545,1.278L26,24.385a10.607,10.607,0,0,0,4.547-1.278,5.294,5.294,0,0,0,1.62-1.388",
    transform: "translate(-17.173 -19.928)",
    fill: "#ff4140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3235",
    "data-name": "Tracciato 3235",
    d: "M27.631,23.009l-.18,24.506a13.367,13.367,0,0,1-2.993-.134l.18-24.506a13.245,13.245,0,0,0,2.993.134",
    transform: "translate(-18.801 -18.55)",
    fill: "#ff4140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3236",
    "data-name": "Tracciato 3236",
    d: "M27.72,25.227l-.182,24.506a10.089,10.089,0,0,1-3.385-1.144,3.864,3.864,0,0,1-2.276-3.181l.18-24.506a3.864,3.864,0,0,0,2.276,3.181,9.989,9.989,0,0,0,3.387,1.144",
    transform: "translate(-21.879 -20.902)",
    fill: "#d83736"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_216",
    "data-name": "Raggruppa 216",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_215",
    "data-name": "Raggruppa 215",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3238",
    "data-name": "Tracciato 3238",
    d: "M35.117,20.18c3.023,1.745,3.045,4.578.039,6.323a12.048,12.048,0,0,1-10.922,0c-3.023-1.745-3.032-4.578-.026-6.323a12.02,12.02,0,0,1,10.909,0",
    transform: "translate(26.183 22.5)",
    fill: "#041f30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3239",
    "data-name": "Tracciato 3239",
    d: "M51.759,32.141,14.15,53.584c-1.278.734-3.036.631-4.979-.482A15.632,15.632,0,0,1,2.083,40.825c0-2.278.8-3.878,2.1-4.621L41.791,14.76c-1.3.743-2.1,2.344-2.1,4.621A15.626,15.626,0,0,0,46.78,31.659c1.94,1.114,3.7,1.217,4.979.482",
    transform: "translate(2.484 17.599)",
    fill: "#d83736"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_218",
    "data-name": "Raggruppa 218",
    transform: "translate(4.567 32.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_217",
    "data-name": "Raggruppa 217",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3240",
    "data-name": "Tracciato 3240",
    d: "M45.232,22.688,7.623,44.131c-.022.013-.044.026-.066.037L45.164,22.725l.068-.037",
    transform: "translate(4.444 -5.305)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3241",
    "data-name": "Tracciato 3241",
    d: "M46.415,22.705,8.806,44.148a3.843,3.843,0,0,1-2.3.4L44.115,23.106a3.85,3.85,0,0,0,2.3-.4",
    transform: "translate(3.193 -5.285)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3242",
    "data-name": "Tracciato 3242",
    d: "M47.924,25.716,10.316,47.159A6.888,6.888,0,0,1,7.7,46.239a13.8,13.8,0,0,1-4.387-4.279L40.923,20.516A13.818,13.818,0,0,0,45.31,24.8a6.888,6.888,0,0,0,2.613.921",
    transform: "translate(-0.613 -7.895)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3243",
    "data-name": "Tracciato 3243",
    d: "M41.9,22.392,4.288,43.835A17.288,17.288,0,0,1,2.5,40.386L40.106,18.941A17.255,17.255,0,0,0,41.9,22.392",
    transform: "translate(-1.587 -9.773)",
    fill: "#ff4140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3244",
    "data-name": "Tracciato 3244",
    d: "M40.6,23.928,2.992,45.372a12.983,12.983,0,0,1-.908-4.547c0-2.278.8-3.878,2.1-4.621L41.789,14.76c-1.3.743-2.1,2.344-2.1,4.621a12.988,12.988,0,0,0,.91,4.547",
    transform: "translate(-2.082 -14.758)",
    fill: "#d83736"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_220",
    "data-name": "Raggruppa 220",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_219",
    "data-name": "Raggruppa 219",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3246",
    "data-name": "Tracciato 3246",
    d: "M33.407,27.763c0,4.532-3.168,6.393-7.081,4.15a15.636,15.636,0,0,1-7.088-12.277c0-4.532,3.177-6.38,7.088-4.137a15.6,15.6,0,0,1,7.081,12.264",
    transform: "translate(22.938 17.344)",
    fill: "#041f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_222",
    "data-name": "Raggruppa 222",
    transform: "translate(22.064 7.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_221",
    "data-name": "Raggruppa 221",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3247",
    "data-name": "Tracciato 3247",
    d: "M72.335,14.871,18.059,45.818c-.033.018-.064.035-.1.055L72.237,14.926l.1-.055",
    transform: "translate(-0.646 10.214)",
    fill: "#052234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3248",
    "data-name": "Tracciato 3248",
    d: "M74.043,14.9,19.767,45.843a5.544,5.544,0,0,1-3.317.579L70.726,15.475a5.55,5.55,0,0,0,3.317-.579",
    transform: "translate(-2.45 10.244)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3249",
    "data-name": "Tracciato 3249",
    d: "M76.219,19.243,21.943,50.19a9.927,9.927,0,0,1-3.771-1.331,19.9,19.9,0,0,1-6.331-6.176L66.117,11.736a19.874,19.874,0,0,0,6.331,6.176,9.889,9.889,0,0,0,3.771,1.331",
    transform: "translate(-7.945 6.476)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3250",
    "data-name": "Tracciato 3250",
    d: "M67.522,14.444,13.247,45.391a24.921,24.921,0,0,1-2.585-4.979L64.938,9.465a24.808,24.808,0,0,0,2.585,4.979",
    transform: "translate(-9.351 3.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3251",
    "data-name": "Tracciato 3251",
    d: "M65.653,16.662,11.377,47.609a18.752,18.752,0,0,1-1.313-6.562c0-3.289,1.16-5.6,3.028-6.671L67.367,3.429C65.5,4.5,64.34,6.812,64.34,10.1a18.752,18.752,0,0,0,1.313,6.562",
    transform: "translate(-10.064 -3.429)",
    fill: "#dcdcdc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_224",
    "data-name": "Raggruppa 224",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_223",
    "data-name": "Raggruppa 223",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3253",
    "data-name": "Tracciato 3253",
    d: "M55.269,22.2c0,6.542-4.573,9.228-10.218,5.989S34.821,17.008,34.821,10.466,39.405,1.259,45.05,4.5,55.269,15.656,55.269,22.2",
    transform: "translate(41.518 3.72)",
    fill: "#041f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_226",
    "data-name": "Raggruppa 226",
    transform: "translate(66.149 0.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_225",
    "data-name": "Raggruppa 225",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3254",
    "data-name": "Tracciato 3254",
    d: "M56.534,13.652l-17.07,9.4c-.037.022-.075.042-.114.064l17.07-9.4c.039-.02.077-.042.114-.064",
    transform: "translate(-19.231 15.491)",
    fill: "#052234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3255",
    "data-name": "Tracciato 3255",
    d: "M58.516,13.681l-17.07,9.4a6.449,6.449,0,0,1-3.854.673l17.07-9.4a6.455,6.455,0,0,0,3.854-.673",
    transform: "translate(-21.327 15.525)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3256",
    "data-name": "Tracciato 3256",
    d: "M61.044,18.731l-17.07,9.4a11.51,11.51,0,0,1-4.38-1.546,23.113,23.113,0,0,1-7.355-7.176l17.07-9.4a23.068,23.068,0,0,0,7.355,7.176,11.51,11.51,0,0,0,4.38,1.546",
    transform: "translate(-27.71 11.148)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3257",
    "data-name": "Tracciato 3257",
    d: "M50.942,13.155l-17.072,9.4a29,29,0,0,1-3-5.786l17.067-9.4a28.944,28.944,0,0,0,3.006,5.783",
    transform: "translate(-29.343 8.003)",
    fill: "#ff4140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3258",
    "data-name": "Tracciato 3258",
    d: "M48.768,15.732l-17.07,9.4a21.763,21.763,0,0,1-1.526-7.625c0-3.819,1.346-6.5,3.519-7.75l17.07-9.4c-2.173,1.245-3.519,3.929-3.519,7.75A21.761,21.761,0,0,0,48.768,15.732Z",
    transform: "translate(-30.173 -0.359)",
    fill: "#d83736"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_228",
    "data-name": "Raggruppa 228",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_227",
    "data-name": "Raggruppa 227",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3260",
    "data-name": "Tracciato 3260",
    d: "M61.715,22.163c0,7.6-5.312,10.721-11.872,6.958S37.959,16.136,37.959,8.538,43.284-2.163,49.844,1.6,61.715,14.564,61.715,22.163",
    transform: "translate(45.26 -0.001)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3261",
    "data-name": "Tracciato 3261",
    d: "M54.143,28a9.088,9.088,0,0,1-4.382-1.364c-5.961-3.418-11-12.146-11-19.056C38.762,3.337,40.575.8,43.616.8a9.13,9.13,0,0,1,4.393,1.366C54.069,5.644,59,14.185,59,21.207,59,25.46,57.182,28,54.143,28",
    transform: "translate(46.217 0.957)",
    fill: "#00b5ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3262",
    "data-name": "Tracciato 3262",
    d: "M28.682,24.917l-.675-.36a1.056,1.056,0,0,0-.167-.079l.675.36a1.057,1.057,0,0,1,.167.079",
    transform: "translate(33.195 29.187)",
    fill: "#d68910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3263",
    "data-name": "Tracciato 3263",
    d: "M28.787,24.878l-.675-.36a1.2,1.2,0,0,0-.5-.07l.675.362a1.241,1.241,0,0,1,.5.068",
    transform: "translate(32.923 29.147)",
    fill: "#d68910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3264",
    "data-name": "Tracciato 3264",
    d: "M28.783,24.809l-.675-.362a2.1,2.1,0,0,0-.912.3l.675.36a2.092,2.092,0,0,1,.912-.3",
    transform: "translate(32.427 29.149)",
    fill: "#eb9611"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3265",
    "data-name": "Tracciato 3265",
    d: "M28.557,24.945l-.675-.36a4.214,4.214,0,0,0-1.261,1.179l.675.362a4.222,4.222,0,0,1,1.261-1.182",
    transform: "translate(31.741 29.313)",
    fill: "#f2a012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3266",
    "data-name": "Tracciato 3266",
    d: "M27.534,25.484l-.675-.36a5.582,5.582,0,0,0-.436.708l.675.362a5.457,5.457,0,0,1,.436-.71",
    transform: "translate(31.504 29.956)",
    fill: "#f2a012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3267",
    "data-name": "Tracciato 3267",
    d: "M27.268,25.808l-.675-.36a5.143,5.143,0,0,0-.314.748l.675.362a5.169,5.169,0,0,1,.314-.75",
    transform: "translate(31.333 30.342)",
    fill: "#f2a012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3268",
    "data-name": "Tracciato 3268",
    d: "M27.065,26.151l-.675-.362a3.855,3.855,0,0,0-.2,1.19,1.546,1.546,0,0,0,.647,1.421l.675.362a1.553,1.553,0,0,1-.647-1.423,3.789,3.789,0,0,1,.2-1.188",
    transform: "translate(31.225 30.749)",
    fill: "#e89a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3269",
    "data-name": "Tracciato 3269",
    d: "M28.706,24.914a4.871,4.871,0,0,0-2.21,3.828c0,1.407,1,1.975,2.225,1.267a4.87,4.87,0,0,0,2.21-3.828c0-1.405-1-1.973-2.225-1.267",
    transform: "translate(31.592 29.344)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3270",
    "data-name": "Tracciato 3270",
    d: "M27.554,28.131c-.318,0-.509-.261-.511-.7a2.519,2.519,0,0,1,1.142-1.975.952.952,0,0,1,.467-.147c.318,0,.509.263.511.7a2.516,2.516,0,0,1-1.142,1.975.959.959,0,0,1-.467.147",
    transform: "translate(32.244 30.174)",
    fill: "#d68910"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_252",
    "data-name": "Raggruppa 252",
    transform: "translate(252 80.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_251",
    "data-name": "Raggruppa 251",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_250",
    "data-name": "Raggruppa 250",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_249",
    "data-name": "Raggruppa 249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_248",
    "data-name": "Raggruppa 248",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_247",
    "data-name": "Raggruppa 247",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_246",
    "data-name": "Raggruppa 246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_245",
    "data-name": "Raggruppa 245",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_232",
    "data-name": "Raggruppa 232",
    transform: "translate(0 2.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_231",
    "data-name": "Raggruppa 231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_230",
    "data-name": "Raggruppa 230",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3271",
    "data-name": "Tracciato 3271",
    d: "M7.74,6.449l2.568-1.535L2.568,1.845,0,3.379Z",
    transform: "translate(0 -1.844)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_235",
    "data-name": "Raggruppa 235",
    transform: "translate(16.887 18.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_234",
    "data-name": "Raggruppa 234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_233",
    "data-name": "Raggruppa 233",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3272",
    "data-name": "Tracciato 3272",
    d: "M11.8,22.585l2.568-1.535-1.4-9.548L10.4,13.039Z",
    transform: "translate(-10.398 -11.503)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_238",
    "data-name": "Raggruppa 238",
    transform: "translate(11.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_237",
    "data-name": "Raggruppa 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_236",
    "data-name": "Raggruppa 236",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3273",
    "data-name": "Tracciato 3273",
    d: "M10.389,11.485l2.568-1.535L9.423,0,6.856,1.535Z",
    transform: "translate(-6.855 0)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_241",
    "data-name": "Raggruppa 241",
    transform: "translate(14.667 9.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_240",
    "data-name": "Raggruppa 240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_239",
    "data-name": "Raggruppa 239",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3274",
    "data-name": "Tracciato 3274",
    d: "M16.8,13.29l2.568-1.535L11.6,6.127,9.032,7.663Z",
    transform: "translate(-9.031 -6.127)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_244",
    "data-name": "Raggruppa 244",
    transform: "translate(0 1.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_243",
    "data-name": "Raggruppa 243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_242",
    "data-name": "Raggruppa 242",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3275",
    "data-name": "Tracciato 3275",
    d: "M11.133.945,7.74,7.009,0,3.94l5.676,9.4L4.427,21.395l6.9-.268,6.967,8.045-1.406-9.546,5.546-3.1L14.667,10.9Z",
    transform: "translate(0 -0.945)",
    fill: "#ffc400"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_276",
    "data-name": "Raggruppa 276",
    transform: "translate(106.944 121.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_251-2",
    "data-name": "Raggruppa 251",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_250-2",
    "data-name": "Raggruppa 250",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_249-2",
    "data-name": "Raggruppa 249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_248-2",
    "data-name": "Raggruppa 248",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_247-2",
    "data-name": "Raggruppa 247",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_246-2",
    "data-name": "Raggruppa 246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_245-2",
    "data-name": "Raggruppa 245",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_232-2",
    "data-name": "Raggruppa 232",
    transform: "translate(0 2.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_231-2",
    "data-name": "Raggruppa 231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_230-2",
    "data-name": "Raggruppa 230",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3271-2",
    "data-name": "Tracciato 3271",
    d: "M7.74,6.449l2.568-1.535L2.568,1.845,0,3.379Z",
    transform: "translate(0 -1.844)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_235-2",
    "data-name": "Raggruppa 235",
    transform: "translate(16.887 18.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_234-2",
    "data-name": "Raggruppa 234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_233-2",
    "data-name": "Raggruppa 233",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3272-2",
    "data-name": "Tracciato 3272",
    d: "M11.8,22.585l2.568-1.535-1.4-9.548L10.4,13.039Z",
    transform: "translate(-10.398 -11.503)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_238-2",
    "data-name": "Raggruppa 238",
    transform: "translate(11.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_237-2",
    "data-name": "Raggruppa 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_236-2",
    "data-name": "Raggruppa 236",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3273-2",
    "data-name": "Tracciato 3273",
    d: "M10.389,11.485l2.568-1.535L9.423,0,6.856,1.535Z",
    transform: "translate(-6.855 0)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_241-2",
    "data-name": "Raggruppa 241",
    transform: "translate(14.667 9.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_240-2",
    "data-name": "Raggruppa 240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_239-2",
    "data-name": "Raggruppa 239",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3274-2",
    "data-name": "Tracciato 3274",
    d: "M16.8,13.29l2.568-1.535L11.6,6.127,9.032,7.663Z",
    transform: "translate(-9.031 -6.127)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_244-2",
    "data-name": "Raggruppa 244",
    transform: "translate(0 1.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_243-2",
    "data-name": "Raggruppa 243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_242-2",
    "data-name": "Raggruppa 242",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3275-2",
    "data-name": "Tracciato 3275",
    d: "M11.133.945,7.74,7.009,0,3.94l5.676,9.4L4.427,21.395l6.9-.268,6.967,8.045-1.406-9.546,5.546-3.1L14.667,10.9Z",
    transform: "translate(0 -0.945)",
    fill: "#ffc400"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_275",
    "data-name": "Raggruppa 275",
    transform: "translate(224 167.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_274",
    "data-name": "Raggruppa 274",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_273",
    "data-name": "Raggruppa 273",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_272",
    "data-name": "Raggruppa 272",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_271",
    "data-name": "Raggruppa 271",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_270",
    "data-name": "Raggruppa 270",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_269",
    "data-name": "Raggruppa 269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_268",
    "data-name": "Raggruppa 268",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_255",
    "data-name": "Raggruppa 255",
    transform: "translate(13.501 2.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_254",
    "data-name": "Raggruppa 254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_253",
    "data-name": "Raggruppa 253",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3276",
    "data-name": "Tracciato 3276",
    d: "M7.71,5.414,5.276,4.04,12.434.992l2.434,1.377Z",
    transform: "translate(-5.276 -0.993)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_258",
    "data-name": "Raggruppa 258",
    transform: "translate(4.159 17.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_257",
    "data-name": "Raggruppa 257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_256",
    "data-name": "Raggruppa 256",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3277",
    "data-name": "Tracciato 3277",
    d: "M4.059,17.193,1.626,15.819,2.716,6.87,5.152,8.244Z",
    transform: "translate(-1.625 -6.87)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_261",
    "data-name": "Raggruppa 261",
    transform: "translate(7.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_260",
    "data-name": "Raggruppa 260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_259",
    "data-name": "Raggruppa 259",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3278",
    "data-name": "Tracciato 3278",
    d: "M5.217,10.75,2.783,9.376,5.852,0,8.288,1.376Z",
    transform: "translate(-2.782 -0.001)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_264",
    "data-name": "Raggruppa 264",
    transform: "translate(0 9.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_263",
    "data-name": "Raggruppa 263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_262",
    "data-name": "Raggruppa 262",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3279",
    "data-name": "Tracciato 3279",
    d: "M2.434,10.475,0,9.1,7.122,3.663,9.556,5.04Z",
    transform: "translate(0 -3.664)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_267",
    "data-name": "Raggruppa 267",
    transform: "translate(2.434 1.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_266",
    "data-name": "Raggruppa 266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_265",
    "data-name": "Raggruppa 265",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3280",
    "data-name": "Tracciato 3280",
    d: "M11.144.537l3.309,5.586,7.16-3.048-5.085,8.911,1.354,7.5L11.43,19.39,5.112,27.067,6.2,18.118.951,15.349,8.073,9.911Z",
    transform: "translate(-0.952 -0.537)",
    fill: "#ffc400"
  })))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelescope);
export default __webpack_public_path__ + "static/media/telescope.3c2233e5a8ae76fb4d65af844685027d.svg";
export { ForwardRef as ReactComponent };